import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { Cross } from '@/assets/icons/Cross'
import { EXCLUSIONS } from './constants'
import styles from './VdcEducationPage.module.scss'

const WhatIsNotIncluded: React.FC = () => (
  <Container className={`${styles.notIncluded} flex flex-column`}>
    {EXCLUSIONS.map((exclusion, index) => (
      <Container key={exclusion}>
        <Container className={`${styles['notIncluded__item']} flex flex-middle`}>
          <Container className={`${styles['notIncluded__icon']} flex flex-middle flex-center`}>
            <Cross stroke="#CD1719" />
          </Container>
          <Typography variant="P2" className={styles['notIncluded__text']}>{exclusion}</Typography>
        </Container>
        {index < EXCLUSIONS.length - 1 && <div className={styles['notIncluded__divider']} />}
      </Container>
    ))}
  </Container>
)

export default WhatIsNotIncluded

